// extracted by css-extract-rspack-plugin
export default {"popover":"RTYtgUjPm8810XaV","arrow":"WVyfa6TmJ9Uaf_hI","slide":"EvtJwhzIbosol2EN","default":"_eLynGtBag0M9mw8","fit":"SiCHQeP5F900RA0A","trigger":"ZRlrDYRYMfUVF11T"};